import { customElement } from "lit/decorators.js";
import { css, html, LitElement } from "lit";

@customElement("ehm-skip-to-content")
export class Reveal extends LitElement {

  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();
    const anchor = this.querySelector("a");
    if (anchor) {
      anchor.addEventListener("click", this.handleClick);
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const anchor = this.querySelector("a");
    if (anchor) {
      anchor.removeEventListener("click", this.handleClick);
    }
  }

  private handleClick = (e: Event) => {
    const anchor = e.currentTarget as HTMLAnchorElement;
    const href = anchor.getAttribute("href");
    if (!href || !href.startsWith("#")) return;

    e.preventDefault();

    const targetId = href.slice(1);
    let targetElement = document.getElementById(targetId);

    // Fallback to first H1 if target not found
    if (!targetElement) {
      targetElement = document.querySelector("h1");
    }

    if (targetElement) {
      const navHeight = 145; // Offset for sticky nav
      const elementPosition = targetElement.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.scrollY - navHeight;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });

      targetElement.setAttribute("tabindex", "-1");
      targetElement.focus();

      history.pushState(null, "", href);
    }
  };

  render() {
    return html`
      <slot></slot>
    `;
  }
}
